/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit';

import {
 commonReducers,
 CommonState,
 initialCommonState,
} from '../_common/commonReducers';

export interface CustomerAddress {
 Id: number;
 AddressId: number;
 State: string;
 City: string;
 StreetEtc: string;
 PostalCode: string;
 Phone: string;
 Modified: string;
}
export interface CustomerEmail {
 Id: number;
 Email: string;
 Name: string;
 Surname: string;
 Phone: string;
 Enabled: boolean;
 Guid: string;
 Modified: string;
 GroupsId: number[];
}

export interface CustomersState extends CommonState {
 addresses: CustomerAddress[];
 emails: CustomerEmail[];
}

const initialState: CustomersState = {
 ...initialCommonState,
 addresses: [],
 emails: [],
};

const customersSlice = createSlice({
 name: 'customers',
 initialState,
 reducers: {
  ...commonReducers,
 },
});

export const {
 getTableStart,
 getTableSuccess,
 getTableFailure,
 getTableFinish,

 getItemStart,
 getItemSuccess,
 getItemFailure,

 createItemStart,
 createItemSuccess,
 createItemFailure,
 createItemFinish,

 updateItemStart,
 updateItemSuccess,
 updateItemFailure,
 updateItemFinish,

 deleteItemsStart,
 deleteItemsSuccess,
 deleteItemsFailure,
 deleteItemsFinish,

 deleteItemStart,
 deleteItemSuccess,
 deleteItemFailure,
 deleteItemFinish,

 getTableStructureStart,
 getTableStructureSuccess,
 getTableStructureFailure,

 getItemDocumentsStart,
 getItemDocumentsSuccess,
 getItemDocumentsFailure,
 getItemDocumentsFinish,

 uploadItemDocumentsStart,
 uploadItemDocumentsSuccess,
 uploadItemDocumentsFailure,
 uploadItemDocumentsFinish,

 deleteItemDocumentStart,
 deleteItemDocumentSuccess,
 deleteItemDocumentFailure,
 deleteItemDocumentFinish,

 getTableExcelStart,
 getTableExcelSuccess,
 getTableExcelFailure,
 getTableExcelFinish,
} = customersSlice.actions;
export default customersSlice;
